module.exports = __webpack_public_path__ + "assets/img/Eimele-2-Landing-Page.5c26d319.jpg";